import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@do/ui/components/dialog";
import { Separator } from "@do/ui/components/separator";
import { cn } from "@do/ui/lib/utils";
import { useTranslations } from "next-intl";
import { Fragment } from "react";
import { HeaderSettingsLanguage } from "./language";
import { HeaderSettingsLegal } from "./legal";
import { HeaderSettingsRefresh } from "./refresh";

type HeaderSettingsProps = {
  showRefreshSection: boolean;
  showLanguageSection: boolean;
  showLegalSection: boolean;
  dialogPortalContainer?: HTMLElement | null;
};

export const HeaderSettings = ({
  showRefreshSection,
  showLanguageSection,
  showLegalSection,
  dialogPortalContainer,
}: HeaderSettingsProps) => {
  const t = useTranslations("do-chat-v2");

  const sections = [];

  if (showLanguageSection) {
    sections.push(<HeaderSettingsLanguage key="language" />);
  }

  if (showRefreshSection) {
    sections.push(<HeaderSettingsRefresh key="refresh" />);
  }

  if (showLegalSection) {
    sections.push(<HeaderSettingsLegal key="legal" />);
  }

  return (
    <DialogContent
      id="header-settings-dialog"
      className={cn(
        "h-(--header-settings-dialog-height) w-(--header-settings-dialog-width) max-w-(--header-settings-dialog-max-width) flex flex-col p-0 gap-0 rounded-(--header-settings-dialog-border-radius) max-h-[95vh] bg-(--header-settings-dialog-background)/(--header-settings-dialog-background-opacity)",
        dialogPortalContainer && "max-h-[92%]"
      )}
      portalContainer={dialogPortalContainer}
      overlayProps={{
        className:
          "bg-(--header-settings-dialog-overlay-background)/(--header-settings-dialog-overlay-background-opacity)",
      }}
    >
      <DialogHeader
        id="header-settings-dialog-header"
        className="p-(--header-settings-dialog-padding) pb-0"
      >
        <DialogTitle
          className={cn(
            "text-(--header-settings-dialog-title-color)/(--header-settings-dialog-title-color-opacity) text-(length:--header-settings-dialog-title-font-size)",
            "font-(--header-settings-dialog-title-font-weight)! font-(family-name:--header-settings-dialog-title-font-family)",
            "leading-(--header-settings-dialog-title-line-height)",
            "text-center"
          )}
        >
          {t("chat.header.settings.title")}
        </DialogTitle>

        <DialogDescription className="sr-only">
          {t("chat.header.settings.description")}
        </DialogDescription>
      </DialogHeader>

      <div
        id="header-settings-dialog-content"
        className="flex-1 flex flex-col gap-(--header-settings-dialog-content-gap) overflow-y-auto"
      >
        {sections.map((section, index) => (
          <Fragment key={index}>
            {section}
            {index < sections.length - 1 && <Separator />}
          </Fragment>
        ))}
      </div>
    </DialogContent>
  );
};
